<template>
    <div class="block-balance">
        <span>{{ value }} {{ value | numerate('балл:::баллa:::баллов') }}</span>
        <span class="block-balance__changes">
            <transition-group name="add">
                <span class="block-balance__change" v-for="item in changes" :key="item.id">+{{ item.value }}</span>
            </transition-group>
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: Number,
                required: true
            }
        },
        data () {
            return {
                changes: []
            }
        },
        watch: {
            value (newValue, oldValue) {
                if (newValue > oldValue) {
                    const id = Date.now()
                    this.changes.push({id, value: newValue - oldValue})
                    setTimeout(() => {
                        const index = this.changes.findIndex(item => item.id === id)
                        this.changes.splice(index, 1)
                    }, 20000)
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .block-balance {
        background-color #fff
        padding 0 3rem
        font-size 1.5rem
        font-weight $font-bold
        color #362AEE
        position relative

        &__changes {
            top 0
            left 0
            position absolute
        }

        &__change {
            position absolute
            top 0
            left 2.2rem
            opacity 0
        }

        span {
            display flex
            height 5.5rem
            align-items center
        }
    }
    .add-enter-active {
        animation add 1s 1 forwards
    }
    @keyframes add {
        0% {
            opacity 0
            transform translate(0, 0)
        }
        50% {
            opacity 1
        }
        100% {
            opacity 0
            transform translate(0, -1.6rem)
        }
    }
</style>
